/* Classify section labels only. Never change product names or stored content. */
(() => {
  const selector = [
    '.mr-collections__heading', '.mr-tradition__title', '.mr-postcards__title',
    '.mr-story__heading', '.mr-history__heading', '.mr-social h2',
    '.related-products__heading', '.complementary-products__heading',
    '.collection-list-title', '.title-wrapper-with-link > .title',
    '#CartDrawer .upsell__outside-title'
  ].join(',');
  function classify(root) {
    const nodes = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) nodes.push(root);
    nodes.forEach(el => {
      const text = el.textContent.trim().replace(/\s+/g, ' ');
      const short = text.length <= 40 && text.split(' ').length <= 6;
      el.classList.toggle('mr-case-section-short', short);
      el.classList.toggle('mr-case-section-long', !short);
    });
  }
  const start = () => {
    classify(document);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') {
          const heading = record.target.parentElement?.closest(selector);
          if (heading) classify(heading);
        } else {
          record.addedNodes.forEach(node => { if (node.nodeType === 1) classify(node); });
        }
      }
    }).observe(document.body, {childList:true, subtree:true, characterData:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
